(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove();
      } else {
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fg-budget-guide"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-fg-budget-tool]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const nav = link.closest('[data-fg-budget-tools]');
  if (!nav) return;
  const tools = new Set(JSON.parse(nav.dataset.fgBudgetTools));
  const url = new URL(window.location.href);
  const current = url.searchParams.getAll('filter.p.product_type');
  const selected = link.dataset.fgBudgetTool;
  url.searchParams.delete('filter.p.product_type');
  for (const tag of current) {
    if (!tools.has(tag)) url.searchParams.append('filter.p.product_type', tag);
  }
  if (!current.includes(selected)) url.searchParams.append('filter.p.product_type', selected);
  url.searchParams.delete('page');
  url.hash = 'ProductGridContainer';
  event.preventDefault();
  window.location.assign(url.href);
});

// The product grid updates independently of the editorial section.
// Read the current URL after the theme has finished updating its history.
(() => {
  const syncSelection = () => {
    const current = new URL(window.location.href);
    const selected = new Set(current.searchParams.getAll('filter.p.product_type'));
    document.querySelectorAll('[data-fg-budget-tools]').forEach((nav) => {
      const tools = new Set(JSON.parse(nav.getAttribute('data-fg-budget-tools')));
      nav.querySelectorAll('a[data-fg-budget-tool]').forEach((link) => {
        const value = link.getAttribute('data-fg-budget-tool');
        const active = selected.has(value);
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
        const icon = link.querySelector('[aria-hidden="true"]');
        if (icon) icon.textContent = active ? '−' : '→';
        const target = new URL(current.href);
        target.searchParams.delete('filter.p.product_type');
        selected.forEach((tag) => {
          if (!tools.has(tag)) target.searchParams.append('filter.p.product_type', tag);
        });
        if (!active) target.searchParams.append('filter.p.product_type', value);
        target.searchParams.delete('page');
        target.hash = 'ProductGridContainer';
        link.href = target.href;
      });
    });
  };
  const scheduleSync = () => queueMicrotask(syncSelection);
  document.addEventListener('collection:rerendered', scheduleSync);
  window.addEventListener('popstate', scheduleSync);
  window.addEventListener('pageshow', scheduleSync);
  document.addEventListener('shopify:section:load', scheduleSync);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncSelection, { once: true });
  } else syncSelection();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fg-category-guide"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-fg-tool]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const nav = link.closest('[data-fg-tools]');
  if (!nav) return;
  const tools = new Set(JSON.parse(nav.dataset.fgTools));
  const url = new URL(window.location.href);
  const current = url.searchParams.getAll('filter.p.tag');
  const selected = link.dataset.fgTool;
  url.searchParams.delete('filter.p.tag');
  for (const tag of current) {
    if (!tools.has(tag)) url.searchParams.append('filter.p.tag', tag);
  }
  if (!current.includes(selected)) url.searchParams.append('filter.p.tag', selected);
  url.searchParams.delete('page');
  url.hash = 'ProductGridContainer';
  event.preventDefault();
  window.location.assign(url.href);
});

// The product grid updates independently of the editorial section.
// Read the current URL after the theme has finished updating its history.
(() => {
  const syncSelection = () => {
    const current = new URL(window.location.href);
    const selected = new Set(current.searchParams.getAll('filter.p.tag'));
    document.querySelectorAll('[data-fg-tools]').forEach((nav) => {
      const tools = new Set(JSON.parse(nav.getAttribute('data-fg-tools')));
      nav.querySelectorAll('a[data-fg-tool]').forEach((link) => {
        const value = link.getAttribute('data-fg-tool');
        const active = selected.has(value);
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
        const icon = link.querySelector('[aria-hidden="true"]');
        if (icon) icon.textContent = active ? '−' : '→';
        const target = new URL(current.href);
        target.searchParams.delete('filter.p.tag');
        selected.forEach((tag) => {
          if (!tools.has(tag)) target.searchParams.append('filter.p.tag', tag);
        });
        if (!active) target.searchParams.append('filter.p.tag', value);
        target.searchParams.delete('page');
        target.hash = 'ProductGridContainer';
        link.href = target.href;
      });
    });
  };
  const scheduleSync = () => queueMicrotask(syncSelection);
  document.addEventListener('collection:rerendered', scheduleSync);
  window.addEventListener('popstate', scheduleSync);
  window.addEventListener('pageshow', scheduleSync);
  document.addEventListener('shopify:section:load', scheduleSync);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncSelection, { once: true });
  } else syncSelection();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();
})();
